import { isActive } from "../../Subscribers/utils/isActive";

/**
 * Fetch user decoders with expiration check.
 * Returns the decoders list plus a parallel boolean array `deletable`.
 * A decoder is deletable only if ALL its packs are expired (no active packs).
 */
export const fetchUserDecoders = async (userId) => {
  const response = await fetch(`/api/user/${userId}/decoders`);
  if (!response.ok) throw new Error("Failed to fetch decoders");
  const data = await response.json();

  const decoders = data?.decoders || [];
  const deletable = decoders?.map((decoder) => 
    !decoder?.packs?.some((pack) => isActive(pack?.expire))
  );

  return { decoders, deletable };
};

